//#region src/compat/_internal/toArray.ts
function toArray(value) {
	return Array.isArray(value) ? value : Array.from(value);
}
//#endregion
export { toArray };
